import { MyLiNKQueryKeys } from "constants/my-link-query-keys";
import UserBookmarkRecord from "models/view-models/user-bookmark-record";
import { useQuery } from "react-query";
import { useParams } from "react-router";
import { t } from "utilities/localization-utils";
import UserBookmarkService, {
    UserBookmarkListQueryParams,
} from "utilities/services/user-bookmarks/user-bookmark-service";
import { ToastManager } from "utilities/toast/toast-manager";
export interface BookmarkQueryResponse {
    bookmarks: UserBookmarkRecord[];
    bookmarksLength: number;
}
export interface UseBookmarksByColorQueryOptions
    extends UserBookmarkListQueryParams {}

export default function useBookmarksByColorQuery(
    options: UseBookmarksByColorQueryOptions
) {
    const { groupId: colors } = useParams<{ groupId: string }>();
    const {
        data: bookmarks,
        isLoading,
        refetch: refetchAllBookmarks,
    } = useQuery({
        queryKey: [
            MyLiNKQueryKeys.BookmarksByColor,
            colors,
            options.sortBy,
            options.searchText,
            options.skip,
            options.take,
            options.currentUserOnly,
        ],
        queryFn: async () => await fetchBookmarks(colors, options),
        keepPreviousData: true,
    });

    return { bookmarks, isLoading, refetchAllBookmarks };
}

const fetchBookmarks = async (
    colors: string,
    options: UserBookmarkListQueryParams
) => {
    try {
        const result = await UserBookmarkService.list({
            colors: [Number(colors)],
            skip: options?.skip,
            take: options?.take,
            searchText: options?.searchText,
            sortBy: options?.sortBy,
            currentUserOnly: options?.currentUserOnly,
        });

        if (result.result?.hasErrors()) {
            throw new Error();
        }
        return {
            bookmarks: result.resultObjects,
            bookmarksLength: result.rowCount,
        };
    } catch (err) {
        ToastManager.error(
            t("errors-actionResource", {
                action: t("loading"),
                resource: t("bookmark_plural"),
            })
        );
    }
};
